import { Map } from 'immutable'

import { DARKLY_SET_FLAGS } from '../actions'

export const initialState = new Map({
  loaded: false,
  flags: {}
})

const darklyReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case DARKLY_SET_FLAGS: {
      return state.set('flags', action.data).set('loaded', true)
    }
    default:
      return state
  }
}

export default darklyReducer
